import { Vue } from 'vue-property-decorator';

import { Apps } from '@/constants/apps';
import MainStorage from '@/storage/main';

import { getApp, generateUniqueId, randomAlphaNumeric } from '@/helpers/core';

const TEMP_ID_LENGTH = 16;
const TEMP_ID_LEGACY_TOWNSHIP_LENGTH = 13;
const TEMP_ID_TOWNSHIP_LENGTH = 24;

export type IdentityUser = {
  id: string | null;
};

export default class IdentityService {
  private static readonly user: IdentityUser = Vue.observable({
    id: null,
  });

  static isInitialized(): boolean {
    return this.user.id !== null;
  }

  static initIdentity(app: Apps): void {
    const id = MainStorage.getTempId(app) || this._generateTempId();

    this._setId(id);
  }

  static getTempUser(): IdentityUser {
    return this.user;
  }

  static getTempUserId(): string | null {
    return this.user.id;
  }

  static updateTempId(id: string): void {
    if (
      id.length !== TEMP_ID_LENGTH &&
      id.length !== TEMP_ID_TOWNSHIP_LENGTH &&
      id.length !== TEMP_ID_LEGACY_TOWNSHIP_LENGTH
    ) {
      throw new TypeError('Incorrect temp id format');
    }

    this._setId(id);
  }

  static refreshIdentity(): void {
    const id = this._generateTempId();

    this._setId(id);
  }

  private static _generateTempId(): string {
    if (getApp() === Apps.Township) {
      return generateUniqueId();
    }

    return randomAlphaNumeric(TEMP_ID_LENGTH);
  }

  private static _setId(id: string): void {
    Object.assign(this.user, { id });

    const app = getApp();
    if (app) {
      MainStorage.saveTempId(app, id);
    }
  }
}
